
const TokenKey = "saas-token";
const langTokenKey = "lang-saas-token";
const tenantCodeKey = "tenantCode";
const RenewToken = "renew-token"
const UserInfoKey = "user-info";
const CurrentRoleKey = "current-role";

// Token 相关操作
export const getToken = () => {
  try {
    return localStorage.getItem(TokenKey);
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const removeToken = () => {
  try {
    localStorage.removeItem(TokenKey);
    localStorage.removeItem(tenantCodeKey);
  } catch (error) {
    console.error("Failed to remove token:", error);
  }
};

export const setToken = (token) => {
  try {
    localStorage.setItem(TokenKey, token);
  } catch (error) {
    console.error("Failed to set token:", error);
  }
};

// 语言相关操作
export const langSetToken = (lang) => {
  try {
    localStorage.setItem(langTokenKey, lang);
  } catch (error) {
    console.error("Failed to set language:", error);
  }
};

export const langGetToken = () => {
  try {
    return localStorage.getItem(langTokenKey) || "zh"; // 默认中文
  } catch (error) {
    console.error("Failed to get language:", error);
    return "zh";
  }
};

export const getRenewToken = () => {
  try {
    return localStorage.getItem(RenewToken);
  } catch (error) {
    console.error("Failed to get tenantCode:", error);
    return null;
  }
}

export const setRenewToken = (token) => {
  try {
    localStorage.setItem(RenewToken, token);
  } catch (error) {
    console.error("Failed to set tenantCode:", error);
  }
}


// 用户信息相关操作
export const getUserInfo = () => {
  try {
    const userInfo = localStorage.getItem(UserInfoKey);
    return userInfo ? JSON.parse(userInfo) : null;
  } catch (error) {
    console.error("Failed to get user info:", error);
    return null;
  }
};

export const setUserInfo = (userInfo) => {
  try {
    localStorage.setItem(UserInfoKey, JSON.stringify(userInfo));
  } catch (error) {
    console.error("Failed to set user info:", error);
  }
};

export const removeUserInfo = () => {
  try {
    localStorage.removeItem(UserInfoKey);
  } catch (error) {
    console.error("Failed to remove user info:", error);
  }
};

// 当前角色相关操作
export const getCurrentRole = () => {
  try {
    const currentRole = localStorage.getItem(CurrentRoleKey);
    return currentRole ? JSON.parse(currentRole) : null;
  } catch (error) {
    console.error("Failed to get current role:", error);
    return null;
  }
};

export const setCurrentRole = (currentRole) => {
  try {
    localStorage.setItem(CurrentRoleKey, JSON.stringify(currentRole));
  } catch (error) {
    console.error("Failed to set current role:", error);
  }
};

export const removeCurrentRole = () => {
  try {
    localStorage.removeItem(CurrentRoleKey);
  } catch (error) {
    console.error("Failed to remove current role:", error);
  }
};



// 请求拦截器（修复命名和逻辑）
export const interceptorsRequest = (config) => {
  config.headers = config.headers || {};

  // Token 注入
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // 多语言设置
  config.headers["x-language"] = langGetToken();

  // 动态处理 Content-Type
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
} else {
    config.headers["Content-Type"] = "application/json; charset=UTF-8";
    config.data = JSON.stringify(config.data);
  }
  // URL 处理
  config.url = (
    config.url.startsWith("/container")|| config.url.startsWith("/file")|| config.url.startsWith("/application")
      ? `/container_proxy/api/${config.url}`
      : `/gw-api/${config.url}`
  ).replaceAll('//', "/");
  // 租户标识

  // 登录账户不用传递tenant
  // if(!config.url.includes('/system/auth/login')){
    const tenantCode = config.url.includes('/system/auth/login')?'ROOT':getTenant();
    config.headers.tenant = tenantCode
  // }
  return config;
};

export const getOssDomain = () => {
  switch (getTenant()) {
    case 'T-MZKJ':
      return import.meta.env.VITE_LIUBIANYUN_BIG_FILE_BASE_URL
    case 'T-GZKJ':
      return import.meta.env.VITE_IZUANKE_BIG_FILE_BASE_URL
    case 'T-PSKJ':
      return import.meta.env.VITE_ZHIHUAIYUN_BIG_FILE_BASE_URL
    default:
      return import.meta.env.VITE_ZHANGJIEYUN_BIG_FILE_BASE_URL
  }
}

// 获取文件域名
export const getFileDomain = ()=>{
  return getOssDomain()
}

export const getImageUrl = (imgUrl) => {
  if (!imgUrl) return '';
  const prefix = getOssDomain()
  const newVal = `${prefix}${imgUrl}`;
  let processedUrl = newVal;
      // 检查是否以 https:// 开头
      if (newVal.startsWith('https://')) {
        // 提取协议部分（前8个字符：'https://'）
        const protocol = newVal.slice(0, 8);
        // 提取剩余路径部分，替换所有双斜杠为单斜杠
        const path = newVal.slice(8).replaceAll('//', '/');
        processedUrl = protocol + path;
      } else {
        // 非 https:// 开头的，直接替换所有双斜杠
        processedUrl = newVal.replaceAll('//', '/');
      }
  return processedUrl
}

// Tenant 相关操作
export const getTenant= () => {
  try {
    return localStorage.getItem(tenantCodeKey);
  } catch (error) {
    console.error("Failed to get token:", error);
    return null;
  }
};

export const setTenant = (token) => {
  try {
    localStorage.setItem(tenantCodeKey, token);
  } catch (error) {
    console.error("Failed to set token:", error);
  }
};
